<template>
	<Page>
		<template #header>Seedphrase</template>

		<SeedViewer :phrase="wallet.seed.phrase" />

		<template #footer>
			<BaseButton variant="link" @click="copy">Copy</BaseButton>
			<BaseButton @click="close">Close</BaseButton>
		</template>
	</Page>
</template>

<script setup lang="tsx">
import Page from '../ui/Page.vue';
import { useWalletStore } from '@/stores/useWalletStore';
import BaseButton from '../ui/BaseButton.vue';
import { useTelegram } from '@/composables/useTelegram';
import SeedViewer from '../SeedViewer.vue';

const wallet = useWalletStore();
const { telegram } = useTelegram();

const close = () => {
	emit('closed');
};

const copy = () => {
	navigator.clipboard.writeText(wallet.seed.phrase);
	telegram.WebApp.showAlert('seedphrase copied to clipboard');
};

const emit = defineEmits(['closed']);
</script>
